<template>
  <base-wrapper>
    <datatable
      compact
      :columns="columns"
      :total="officeExpeditions.meta.page.total"
      :perPage="officeExpeditions.meta.page.perPage"
      :currentPage="officeExpeditions.meta.page.currentPage"
      :meta="officeExpeditions.meta"
      @pagechanged="onChangePage"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="officeExpedition in officeExpeditions.data"
          :key="officeExpedition.id"
          :class="['cursor-pointer bg-white hover:bg-green-100', classes.tr]"
          @click="onDetail(officeExpedition)"
        >
          <td :class="classes.td">
            <p class="font-bold text-gray-900">
              {{ officeExpedition.attributes.name }}
            </p>
          </td>
          <td :class="classes.td">
            {{ officeExpedition.attributes.shipment_count }}
          </td>
          <td :class="classes.td">
            <base-badge color="indigo">{{
              officeExpedition.attributes.status
            }}</base-badge>
          </td>
        </tr>
      </template>
    </datatable>

    <view-office-expedition-shipment
      :visible="detailShipment.visible"
      :office-expedition-id="detailShipment.id"
      @close="detailShipment.visible = false"
      @completed="onCompleted"
    />

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';
import ViewOfficeExpeditionShipment from '../../../../components/expedition/view-office-expedition-shipment.vue';

export default {
  mixins: [requestMixin],
  components: {
    ViewOfficeExpeditionShipment,
  },
  data() {
    return {
      detailShipment: {
        visible: false,
        id: null,
      },
      officeExpeditions: {
        data: [],
        meta: {
          page: {},
        },
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    columns() {
      return [
        { id: 'name', name: 'Nama Ekspedisi' },
        { id: 'shipment_count', name: 'Jumlah Pengiriman' },
        { id: 'status', name: 'Status Pengiriman' },
      ];
    },
  },
  methods: {
    async loadOfficeExpeditions(params) {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.me.office_id}/office-expeditions`,
        {
          params: {
            'fields[office-expeditions]':
              'name,shipment_count,status,has_awaiting_pickup',
            'page[size]': 5,
            'filter[has_pending_shipment]': true,
            ...params,
          },
        }
      );

      if (!err) {
        this.officeExpeditions = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOfficeExpeditions({
        'page[number]': page,
      });
    },
    onCompleted() {
      this.detailShipment.visible = false;

      this.loadOfficeExpeditions();
    },
    onDetail(officeExpedition) {
      if (officeExpedition.attributes.has_awaiting_pickup) {
        this.detailShipment.visible = true;
        this.detailShipment.id = officeExpedition.id;
      } else {
        this.$router.push({
          name: 'pengiriman-ekspedisi.tambah',
          params: { id: officeExpedition.id },
        });
      }
    },
  },
  created() {
    this.loadOfficeExpeditions();
  },
};
</script>
